import React, { useState } from 'react';
import { Dialog, makeStyles } from '@material-ui/core';
import AboutModal from './AboutModal';
import './styles.css';

const useStyles = makeStyles(() => ({
  paper: {
    borderRadius: 12,
    overflow: 'hidden',
    background: 'transparent',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
  },
  backdrop: {
    backgroundColor: 'rgba(8, 14, 24, 0.7)',
    backdropFilter: 'blur(4px)',
  },
}));

const SidebarFooter = ({ onToggle, isCollapsed }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const classes = useStyles();

  return (
    <>
      <div className="sidebar-footer">
        <div className="sidebar-footer-left" onClick={() => setIsModalOpen(true)}>
          <div className="sidebar-footer-icon">
            <img src="/images/Login-SL8-Logo@2x.png" alt="" />
          </div>
          <div className="sidebar-footer-logo">
            <img src="/images/Login-SL8-Logo@2x.png" alt="Slate Pages" />
          </div>
        </div>
        <button
          className="sidebar-collapse-btn"
          onClick={onToggle}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            {isCollapsed ? (
              <>
                <path d="M18 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H6V5h12v14z"/>
                <path d="M10 17l5-5-5-5v10z"/>
              </>
            ) : (
              <>
                <path d="M18 3H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H6V5h12v14z"/>
                <path d="M14 7l-5 5 5 5V7z"/>
              </>
            )}
          </svg>
        </button>
      </div>

      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          className: classes.paper,
        }}
        BackdropProps={{
          className: classes.backdrop,
        }}
      >
        <AboutModal onClose={() => setIsModalOpen(false)} />
      </Dialog>
    </>
  );
};

export default SidebarFooter;
